import { SimpleLink } from '@components/simpleLink';
import { cn } from '@utils/helpers';
import { graphql, useFragment } from 'react-relay';
import type { SiblingNavigationPropsType } from './types';

export const SiblingNavigation: React.FC<SiblingNavigationPropsType> = (props) => {
  const siblingNavigation = useFragment(
    graphql`
      fragment SiblingNavigation_siblingNavigation on SiblingNavigation {
        links {
          url
          ...SimpleLink_simpleLink
        }
      }
    `,
    props.siblingNavigation,
  );

  return (
    <nav className={cn('Base-inlineNav-wrapper', props.className)}>
      <ul>
        {siblingNavigation?.links.map((link) => (
          <li key={link.url}>
            <SimpleLink simpleLink={link} />
          </li>
        ))}
      </ul>
    </nav>
  );
};
